export default __webpack_public_path__ + "locales/en/DeleteSelfProfileDialog.json?hash=7ee4c65c09b4a636e98474989b738533";